export default function TownMultiSelect({
  towns,
  selected,
  onChange,
}: {
  towns: string[];
  selected: string[];
  onChange: (towns: string[]) => void;
}) {
  function toggle(town: string) {
    onChange(selected.includes(town) ? selected.filter((t) => t !== town) : [...selected, town]);
  }
  const label = selected.length === 0 ? "All towns" : selected.length === 1 ? selected[0] : `${selected.length} towns`;
  return (
    <details style={{ position: "relative" }}>
      <summary
        style={{
          cursor: "pointer",
          padding: "6px 8px",
          border: "1px solid var(--border)",
          borderRadius: 6,
          background: "var(--bg)",
          fontSize: 13,
          minWidth: 100,
        }}
      >
        {label}
      </summary>
      <div
        style={{
          position: "absolute",
          top: "calc(100% + 4px)",
          left: 0,
          zIndex: 10,
          background: "var(--panel)",
          border: "1px solid var(--border)",
          borderRadius: 6,
          padding: 8,
          display: "flex",
          flexDirection: "column",
          gap: 4,
          minWidth: 140,
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        {towns.length === 0 && (
          <span className="muted" style={{ fontSize: 12 }}>
            No towns yet
          </span>
        )}
        {towns.map((town) => (
          <label key={town} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
            <input type="checkbox" checked={selected.includes(town)} onChange={() => toggle(town)} />
            {town}
          </label>
        ))}
      </div>
    </details>
  );
}
